export const ProjectActionTypes = {
    ADD_PROJECT_SUCCESS: 'ADD_PROJECT_SUCCESS',
    FETCH_PROJECTS: 'FETCH_PROJECTS',
    FETCH_PROJECTS_SUCCESS: 'FETCH_PROJECTS_SUCCESS',

 };